import { Action, Mutation, Module, VuexModule } from "vuex-module-decorators";
import { Actions, Mutations } from "@/store/enums/StoreEnums";
import { NewsDto } from "@/components/news/dto";



interface StoreInfo {
 news: NewsDto;
}

@Module
export default class NewsModule extends VuexModule implements StoreInfo {
  news = {} as NewsDto;

  /**
   * Get breadcrumb object for current page
   * @returns object
   */
  get getNews(): NewsDto {
    return this.news;
  }

  @Mutation
  [Mutations.SET_NEWS_MUTATION](payload) {
    this.news = payload;
  }

  @Action
  [Actions.SET_NEWS_ACTION](payload) {
    this.context.commit(Mutations.SET_NEWS_MUTATION, payload);
  }
}
